import Styled from 'styled-components';

const namespace = 'create-password';

export const CreatePasswordContainer = Styled.div`
  margin-top: 10%;
  display: flex;
  justify-content: center;

  .${namespace} {
    max-width: 750px;
    width: 100%;

    .${namespace}-body {
      padding: 16px 32px;
      box-sizing: border-box;

      .${namespace}-body-text {
        margin-bottom: 16px;
      }
    }

    .${namespace}-input-validation-success {
      display: flex;
      svg {
        stroke: var(--allie-color-success-main);
        margin-right: 8px;
      }
    }

    .${namespace}-input-validation-failed {
      display: flex;
      svg {
        stroke: var(--allie-color-neutral-50);
        margin-right: 8px;
      }
    }

    .${namespace}-accordion {
      margin: 0 0 8px 0;
      padding: 16px 32px;

      .${namespace}-accordion-header {
        background: var(--allie-color-neutral-5);
        color: var(--allie-color-neutral-40);
        ion-icon {
          color: var(--allie-color-neutral-40);
          padding-right: 8px;
        }
      }

      .${namespace}-accordion-content {
        background: var(--allie-color-neutral-5);
        border-top: 1px;
        border-top-color: var(--allie-color-neutral-20);
        border-top-style: solid;
        padding: 8px;
      }
    }

    .${namespace}-confirm {
      padding: 16px 32px;
      box-sizing: border-box;
      display: flex;
      justify-content: end;
    }
  }
`;

export const ValidationItem = Styled.div`
  margin-top: 8px;
`;
